export default "__VITE_ASSET__009707d3__"